// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-card-tabs .md-list .md-list-item.disabled .md-list-item-button:focus,.md-card-tabs .md-list .md-list-item.disabled .md-list-item-button:hover{background-color:inherit!important;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
